import React, { useContext } from "react";
import { AppContext } from "../../context";
import { facilitiesIcons } from "../Icons/facilitiesIcons";

function FacilityRow({ facility }) {
  const info = useContext(AppContext);
  return (
    <div
      style={{
        display: "inline-block",
        marginRight: 20,
      }}
    >
      <div
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          marginRight: 6,
        }}
      >
        {facilitiesIcons[facility]}
      </div>
      <div style={{ display: "inline-block" }}>{info.t(facility)}</div>
    </div>
  );
}

export default FacilityRow;
